import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { RetailerNetworkLocationGroupFilter } from '@occc/graphql';
import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';

import { RetailerNetworkUserDetailsLocationGroupsTable } from './retailer-network-user-details-location-groups-table.component';

import { useGetRetailerNetworkLocationGroups } from '../../../../data-access/queries';
import { routeCreator } from '../../../retailer-connect.utils';

type RetailerNetworkUserDetailsLocationGroupsTableContainerProps = {
  filter: RetailerNetworkLocationGroupFilter;
  retailerNetworkUuid: string;
  handleRemoveUserFromLocationGroup: (locationGroupUuid: string) => void;
  isCurrentUserPermittedToDisassociate: boolean;
};

const RetailerNetworkUserDetailsLocationGroupsTableContainer = ({
  filter,
  retailerNetworkUuid,
  handleRemoveUserFromLocationGroup,
  isCurrentUserPermittedToDisassociate,
}: RetailerNetworkUserDetailsLocationGroupsTableContainerProps) => {
  const navigate = useNavigate();
  const [paginationInfo, onPageChange] = usePaginationParams({
    beforeParamName: 'group-before',
    afterParamName: 'group-after',
  });

  const locationGroupsData = useGetRetailerNetworkLocationGroups({
    filter,
    paginationInfo,
    onPageChange,
  });

  const handleOpenLocationGroupDetailsPage = useCallback(
    (locationGroupUuid: string) => {
      navigate(routeCreator.locationGroupDetails(retailerNetworkUuid, locationGroupUuid));
    },
    [navigate, retailerNetworkUuid],
  );

  return (
    <RetailerNetworkUserDetailsLocationGroupsTable
      locationGroupsData={locationGroupsData}
      handleOpenLocationGroupDetailsPage={handleOpenLocationGroupDetailsPage}
      handleRemoveUserFromLocationGroup={handleRemoveUserFromLocationGroup}
      isCurrentUserPermittedToDisassociate={isCurrentUserPermittedToDisassociate}
    />
  );
};

export default RetailerNetworkUserDetailsLocationGroupsTableContainer;
